import { Button, Dialog, DialogActions, DialogTitle, TextField } from "@mui/material"
import React from "react"
import { DEFAULTGAP } from "../../globals"

export const DbConfirmTaskDialog = (props: {
  open: boolean,
  onClose?: (event: {}, reason: "backdropClick" | "escapeKeyDown") => void,
  onCancelClick?: React.MouseEventHandler<HTMLButtonElement> | undefined,
  onConfirmClick?: React.MouseEventHandler<HTMLButtonElement> | undefined,
  onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
  scriptSql: string,
}) => {
  return <>
    <Dialog open={props.open} onClose={props?.onClose} maxWidth={"md"} fullWidth>
      <DialogTitle>Confirmação de Tarefa</DialogTitle>
      <TextField
        defaultValue={props.scriptSql}
        multiline maxRows={25}
        style={{
          marginInline: DEFAULTGAP,
        }}
        onChange={props.onChange}
      />

      <DialogActions>
        <div style={{
          margin: DEFAULTGAP / 2,
          display: 'flex',
          gap: DEFAULTGAP,
        }}>
          <Button onClick={props.onCancelClick}>Cancelar</Button>
          <Button variant="contained" onClick={props.onConfirmClick}>Confirmar</Button>
        </div>
      </DialogActions>
    </Dialog>
  </>
}